define('entities/threads',[
  'app',
  'jquery',
  'backbone',
  'underscore',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  Backbone,
  _,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.Thread = Backbone.Model.extend({
    idAttribute: 'threadId',

    getLastSenderName: function () {
      var name = '';
      if (this.get('lastFrom') && this.get('lastFrom').length > 0) {
        if (this.get('lastFrom')[0].personal)
          name = this.get('lastFrom')[0].personal;
        if (name === '')
          name = this.get('lastFrom')[0].address;
      }
      return name;
    },

    getLastSenderAddress: function () {
      var address = '';
      if (this.get('lastFrom') && this.get('lastFrom').length > 0) {
        address = this.get('lastFrom')[0].address;
      }
      return address;
    },

    addLabel: function (fromSecId, label) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') +
          '/labels?label=' + encodeURIComponent(label.id || label.name));

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    removeLabel: function (fromSecId, label) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') +
          '/labels?label=' + encodeURIComponent(label.id || label.name));

      $.ajax({
        method: 'DELETE',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    trash: function (fromSecId) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') + '/trash');

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    untrash: function (fromSecId) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') + '/untrash');

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    markRead: function (fromSecId) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') + '/read');

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    markUnread: function (fromSecId) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/threads/' +
          fromSecId + '/' +
          this.get('threadId') + '/unread');

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    }
  });

  var API = {
    fromMail: [],

    getThreadsUrl: function (secId, params) {
      return Settings.url('compuzz2', 'mails/threads/' + secId, params);
    },

    getThreadUrl: function (secId, threadId) {
      return Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId);
    },

    getFromMails: function () {
      var defer = $.Deferred();

      if (API.fromMail.length > 0)
        defer.resolve(API.fromMail);
      else {
        $.ajax({
          type: 'GET',
          url: Settings.url('compuzz2', 'v2/userpid/emailAddresses'),
          contentType: 'application/json',
          success: function (mails) {
            API.fromMail = mails;
            defer.resolve(mails);
          }
        });
      }

      return defer.promise();
    },

    replyToThread: function (secId, threadId, data) {
      var defer = $.Deferred();

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId + '/reply'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    },

    forwardMessage: function (secId, threadId, messageId, data) {
      var defer = $.Deferred();

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId +
          '/messages/' + messageId + '/forward'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    },

    createDraft: function (secId, threadId, data, subject) {
      var defer = $.Deferred();
      var params = {};
      if (subject) params.subject = subject;

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId + '/draft', params),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    },

    updateDraft: function (secId, threadId, draftId, data, subject) {
      var defer = $.Deferred();
      var params = {};
      if (subject) params.subject = subject;

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId + '/draft/' + draftId, params),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    },

    // replyWatch: optional {notifyOnReply, salesInboxItemSecId}.
    sendDraft: function (secId, threadId, draftId, replyWatch) {
      var defer = $.Deferred();
      var params = {};
      if (replyWatch && replyWatch.notifyOnReply) {
        params.notifyOnReply = true;
        if (replyWatch.salesInboxItemSecId) params.salesInboxItemSecId = replyWatch.salesInboxItemSecId;
      }

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId + '/draft/' + draftId + '/send', params),
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    },

    discardDraft: function (secId, threadId, draftId) {
      var defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: Settings.url('compuzz2', 'mails/threads/' + secId + '/' + threadId + '/draft/' + draftId),
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('threads:model', function (data) {
    var tt;
    if (data) {
      tt = Backbone.Relational.store.find(app.ns.Thread, data.threadId);
    }
    if (tt) {
      return tt;
    } else {
      return new app.ns.Thread(data);
    }
  });

  App.reqres.setHandler('threads:getFromMails', function () {
    return API.getFromMails();
  });

  App.reqres.setHandler('threads:get-url', function (secId, params) {
    return API.getThreadsUrl(secId, params);
  });

  App.reqres.setHandler('threads:get-thread-url', function (secId, threadId) {
    return API.getThreadUrl(secId, threadId);
  });

  App.reqres.setHandler('threads:reply', function (secId, threadId, data) {
    return API.replyToThread(secId, threadId, data);
  });

  App.reqres.setHandler('threads:forward', function (secId, threadId, messageId, data) {
    return API.forwardMessage(secId, threadId, messageId, data);
  });

  App.reqres.setHandler('threads:create-draft', function (secId, threadId, data, subject) {
    return API.createDraft(secId, threadId, data, subject);
  });

  App.reqres.setHandler('threads:update-draft', function (secId, threadId, draftId, data, subject) {
    return API.updateDraft(secId, threadId, draftId, data, subject);
  });

  App.reqres.setHandler('threads:send-draft', function (secId, threadId, draftId, replyWatch) {
    return API.sendDraft(secId, threadId, draftId, replyWatch);
  });

  App.reqres.setHandler('threads:discard-draft', function (secId, threadId, draftId) {
    return API.discardDraft(secId, threadId, draftId);
  });
});

